import {BS2BottomStickyWildElement} from "./parts/BS2BottomStickyWildElement";
import {BS2Statics} from "../config/BS2Statics";
import {gsap} from "gsap";
import {WildSpinAnimName} from "../server/BS2Data";


export class BS2BottomStickyWildViewController extends PIXI.Container {
    private _bottomStickyWildEleArray: BS2BottomStickyWildElement[] = [];
    private _positionOffsetY: number = 20;

    constructor() {
        super();
        this.init();
        this.position.set(BS2Statics.SYMBOL_WIDTH / 2, BS2Statics.SYMBOL_HEIGHT * 5 + this._positionOffsetY);
        for (let reelIdx: number = BS2Statics.NR_OF_REELS - 1; reelIdx >= 0; reelIdx--) {
            this.addChild(this._bottomStickyWildEleArray[reelIdx]);
        }
    }

    public isLocked(reelId: number): boolean {
        return this._bottomStickyWildEleArray[reelId].isLocked;
    }

    public isVisible(reelId: number): boolean {
        return this._bottomStickyWildEleArray[reelId].isVisible;
    }

    public unLockStickyWildTree(reelIdx: number, shouldPlayWildOpeningSound: boolean, durr: number = 0.3, includeInTL: boolean = false, fromNormalBet: boolean = false): gsap.core.Timeline {
        return this._bottomStickyWildEleArray[reelIdx].unLockStickyWildTree(durr, includeInTL, fromNormalBet, shouldPlayWildOpeningSound);
    }

    public lockStickyWildTree(reelIdx: number, durr: number = 0.3, includeInTL: boolean = false): gsap.core.Timeline {
        return this._bottomStickyWildEleArray[reelIdx].lockStickyWildTree(durr, includeInTL);
    }

    public removeStickyWild(reelIdx: number, shouldPlayWildOpeningSound: boolean = false, durr: number = 0.3, includeInTL: boolean = false): gsap.core.Timeline {
        return this._bottomStickyWildEleArray[reelIdx].removeStickyWild(durr, includeInTL, shouldPlayWildOpeningSound);

    }

    public showStickyWild(reelIdx: number, durr: number = 0.3, includeInTl: boolean = false): gsap.core.Timeline {
        return this._bottomStickyWildEleArray[reelIdx].showStickyWild(durr, includeInTl);
    }

    public resetStickyWildFireAnimOnBet(reelIdx: number): void {
        return this._bottomStickyWildEleArray[reelIdx].resetStickyWildAnimOnBet();
    }

    public playWildAnimByName(reelIdx: number, animName: WildSpinAnimName, includeInTl: boolean, loop: boolean = false): gsap.core.Timeline {
        return this._bottomStickyWildEleArray[reelIdx].playWildAnimByName(animName, includeInTl, loop);
    }

    public playWildEyesFireAnim(reelIdx: number, animName: WildSpinAnimName,isRestore:boolean=false): gsap.core.Timeline | undefined {
        return this._bottomStickyWildEleArray[reelIdx].playWildEyesFireAnim(animName,isRestore);
    }


    public playNoWinAnim(reelIdx: number, durr: number = 0.2): gsap.core.Timeline {
        return gsap.timeline().add((): void => {
            this._bottomStickyWildEleArray[reelIdx].playNoWinAnimation(durr);
        });
    }

    public playAnimAfterNoWin(reelIdx: number, durr: number = 0.03): gsap.core.Timeline {
        return gsap.timeline().add((): void => {
            this._bottomStickyWildEleArray[reelIdx].playAnimAfterNoWin(durr);
        });
    }

    private init(): void {
        for (let reelIdx: number = 0; reelIdx < BS2Statics.NR_OF_REELS; reelIdx++) {
            const lockTree: BS2BottomStickyWildElement = new BS2BottomStickyWildElement(reelIdx);
            this._bottomStickyWildEleArray.push(lockTree);
        }
    }

}